import { buildTCLinkURL } from '../../../../../_shared';

class LinkView {

	constructor(node, view, scope, scopeId) {

		this.node = node;
		this.view = view;

		// Set up the link DOM node
		const mark = this.node.type.spec.toDOM(this.node);

		const type = mark[0]; // "a"
		const attrs = mark[1];

		// Create the link DOM node
		this.dom = document.createElement(type);

		// Copy the sanitized properties from the mark's toDOM() method
		this.dom.setAttribute('href', attrs.href);
		this.dom.setAttribute('rel', 'noopener noreferrer');
		this.dom.setAttribute('target', attrs.target || '_blank');
		this.dom.setAttribute('aria-describedby', 'link-input-tooltip');

		if (attrs.id) {
			this.dom.setAttribute('id', attrs.id);
		}

		if (attrs.title) {
			this.dom.setAttribute('title', attrs.title);
		}

		// Check if we need to convert to the TechChange Link API
		// when rendering the final read-only version of the link
		if (!view.editable && scope && scopeId) {

			this.dom.setAttribute(
				'href',
				buildTCLinkURL(this.dom.href, scope, scopeId, this.dom.id),
			);

			this.dom.setAttribute('rel', 'noopener');

		}

	}

}

export default LinkView;
